import {
  FETCH_DASHBOARD_DATA,
  FETCH_TOP_PRODUCTS,
  FETCH_TOP_BRANDS,
  FETCH_TOP_FRANCHISES,
  FETCH_TOP_VM,
  FETCH_SHIPPING_ANALYTICS,
  FETCH_PURCHASE_ANALYTICS,
  FETCH_PAYMENT_MODE_ANALYTICS,
  FETCH_TOP_RETAILERS,
} from "../../constants/action.constants";

const initialState = {
  dashboardData: {},
  topProducts: [],
  topBrands: [],
  topFranchises: [],
  topVM: [],
  shippingAnalytics: {},
  purchaseAnalytics: {},
  paymentModeAnalytics: {},
  topRetailers: [],
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DASHBOARD_DATA:
      return { ...state, dashboardData: action.payload };
    case FETCH_TOP_PRODUCTS:
      return {
        ...state,
        topProducts: action.payload,
        otherProducts: action.others,
      };
    case FETCH_TOP_BRANDS:
      return {
        ...state,
        topBrands: action.payload,
        otherBrands: action.others,
      };
    case FETCH_TOP_FRANCHISES:
      return { ...state, topFranchises: action.payload };
    case FETCH_TOP_VM:
      return { ...state, topVM: action.payload, others: action.others };
    case FETCH_SHIPPING_ANALYTICS:
      return { ...state, shippingAnalytics: action.payload };
    case FETCH_PURCHASE_ANALYTICS:
      return { ...state, purchaseAnalytics: action.payload };
    case FETCH_PAYMENT_MODE_ANALYTICS:
      return { ...state, paymentModeAnalytics: action.payload };
    case FETCH_TOP_RETAILERS:
      return {
        ...state,
        topRetailers: action.payload,
      };

    default:
      return state;
  }
};

export default dashboardReducer;
